import { ELocationType } from '~/features/agents/models'

export const LOCATION_STREET_ADDRESS_1_MAX_LENGTH = 255
export const LOCATION_STREET_ADDRESS_2_MAX_LENGTH = 255
export const LOCATION_CITY_MAX_LENGTH = 100
export const LOCATION_STATE_MAX_LENGTH = 100
export const LOCATION_ZIP_CODE_MAX_LENGTH = 100
export const LOCATION_COUNTRY_MAX_LENGTH = 100
export const LOCATION_WEBSITE_MAX_LENGTH = 400

export const LOCATION_TYPE_OPTIONS = [
  { label: 'Single Location', value: ELocationType.single },
  { label: 'Multi-Location Hub', value: ELocationType.multi },
  { label: 'Virtual / Online Only', value: ELocationType.virtual },
]
